import { Avatar, Button } from '@heroui/react';
import { LogoutCurve } from 'iconsax-react';
import { useUser } from '../../../entites/authorization/use-user.ts';

export const UserExitButton = () => {
  const { isAuthenticated, logout } = useUser();
  if (isAuthenticated) {
    return (
      <>
        <div className="bg-[#F8F9FA] h-2 -mx-4 lg:hidden" />
        <div className="-mx-4 lg:mt-6">
          <Button
            onPress={logout}
            fullWidth
            size="lg"
            radius="none"
            className="bg-transparent py-4 h-14 max-h-none font-medium justify-start text-[#F53639]"
            startContent={
              <Avatar
                className="bg-[#F5F5F5] text-base"
                radius="lg"
                size="md"
                showFallback
                fallback={<LogoutCurve size="24" color="#F53639" />}
              />
            }
          >
            Выйти из аккаунта
          </Button>
        </div>
      </>
    );
  }
  return null;
};
